import { Grid, Space } from "../components/Layout";
import { Media, Title, Texts, Button } from "../components/Object";
import { Head, News } from "../components/Project";
import { List, NavList } from "../components/Project/Merit";
import { HashLink } from "react-router-hash-link";

const Service = () => {
  const args = {
    slug: "service",
    length: 4,
    addText: [
      [
        '外国人実習生共同受け入れ事業',
        '外国人技能実習制度とは、日本の国際協力・国際貢献の重要な一翼を担っている政府公認の制度です。日本国内の企業において、先進技術・技能・知識等を学び、帰国後に母国の経済発展のために日本で習得した技術を活かし、役立ててもらうための制度です。結協同組合では信頼とスピード、安全第一なサポート体制で各組合員様の国際化及び国際貢献をお手伝いしております。',
      ],
      [
        '経営コンサルタント業',
        '経営コンサルタントとは、言葉の通り経営全般のコンサルティングを行うコンサルタント業務です。<br>財務から戦略までのトータルに携わり、経営者と一緒に企業を成長させていくパートナー的存在になることが求められます。経営に関する幅広い知識と正確な分析力、判断力でサポートいたします。',
      ],
      [
        '補助金等申請サポート',
        '助成金・補助金の相談、申請の支援をさせていただきます。 助成金は、融資とは異なり、返済の必要がない資金を指します。公募型助成金に採択されるために、できる限り精度の高い申請書のサポートをさせていただきます。',
      ],
      [
        '協同購買事業',
        '組合員様の事業経営上の負担軽減を目的として、事業用機器及びオフィス備品・消耗品等を含めたあらゆる商品の共同購入を行なっています。価格も組合員様価格にてご提供させていただきます。',
      ],
    ],
  };
  return (
    <>
      <Head slug="page-service"></Head>
      
      <Space size={['80px', '64px']} />

        <div className="l-row l-row--normal">
          <div className="c-grid__wrap--repeat-button">
            <Button link="/service/#list0" linkType="hash" slug="service0" type="gray"></Button>
            <Button link="/service/#list1" linkType="hash" slug="service1" type="gray"></Button>
            <Button link="/service/#list2" linkType="hash" slug="service2" type="gray"></Button>
            <Button link="/service/#list3" linkType="hash" slug="service3" type="gray"></Button>
          </div>
        </div>

      <Space size={['80px', '64px']} />

      <div className="p-box__wrap--gray" data-state="top-bottom">
        <Space size={['120px', '80px']} />
        <List {...args} />

        <Space size={['120px 0 0', '80px 0 0']}>
          <NavList />
        </Space>
        <Space size={['120px', '80px']} />
      </div>
    
      <Space size={['120px 0 15px', '80px 0 12px']}>
        <News />
      </Space>
    </>
  )
}

export default Service;